// extracted by mini-css-extract-plugin
export default {"sectionContent":"SectionContent_sectionContent__zQmiL","draft":"SectionContent_draft__bMkka","approved":"SectionContent_approved__h4dFr"};